import { Typography, Box } from "@mui/material";
import React from "react";
export function Works() {
  const list = (headingi, l) => (
    <>
      {l.map((t, i) => (
        <React.Fragment key={`${t.h}${i}`}>
          <p>
            <span>{`${headingi + 1}.${i + 1} ${t.h}`}</span>
          </p>
          <Box sx={{ pb: `1rem` }}>{t.b}</Box>
        </React.Fragment>
      ))}
    </>
  );
  const bullet = (l) => (
    <>
      {l.map((t, i) => (
        <Box key={`${t}${i}`} sx={{ display: "flex" }}>
          •<p style={{ paddingLeft: `1rem` }}>{t}</p>
        </Box>
      ))}
    </>
  );
  return (
    <Box sx={{ backgroundColor: "white" }}>
      <Box sx={{ p: `3rem 10%` }}>
        <Typography variant="h4" color={"primary"}>
          <strong>Privacy Policy</strong>
        </Typography>
        <Typography variant="caption" color={"secondary.dark"}>
          Last updated Jan, 1 2022
        </Typography>
        <Box
          sx={{
            pt: `3rem`,
            color: (theme) => theme.palette.grey[700],
            "& span": {
              pr: 1,
              color: `secondary.dark`,
            },
          }}
        >
          {[
            {
              h: `INTRODUCTION`,
              b: `Polycaik LLC (“we” or “us” or “our”) respects the privacy of our users (“user” or “you”). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website www.polycaik.com, including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the “Site”). Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.

                  We reserve the right to make changes to this Privacy Policy at any time and for any reason. We will alert you about any changes by updating the “Last Updated” date of this Privacy Policy. Any changes or modifications will be effective immediately upon posting the updated Privacy Policy on the Site, and you waive the right to receive specific notice of each such change or modification.
                  
                  You are encouraged to periodically review this Privacy Policy to stay informed of updates. You will be deemed to have been made aware of, will be subject to, and will be deemed to have accepted the changes in any revised Privacy Policy by your continued use of the Site after the date such revised Privacy Policy is posted.
                  
                  We may collect information about you in a variety of ways. The information we may collect on the Site includes:`,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `Personal Data`,
                    b: `Personally identifiable information, such as your name, shipping address, email address, and telephone number, and demographic information, such as your age, gender, hometown, and interests, that you voluntarily give to us when you register with the Site or when you choose to participate in various activities related to the Site, such as online chat and message boards. You are under no obligation to provide us with personal information of any kind, however your refusal to do so may prevent you from using certain features of the Site.`,
                  },
                  {
                    h: `Derivative Data`,
                    b: `Information our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site.`,
                  },
                  {
                    h: `Financial Data`,
                    b: `Financial information, such as data related to your payment method (e.g. valid credit card number, card brand, expiration date) that we may collect when you purchase, order, return, exchange, or request information about our services from the Site. We store only very limited, if any, financial information that we collect. Otherwise, all financial information is stored by our payment processor, Paypal, Stripe, and you are encouraged to review their privacy policy and contact them directly for responses to your questions.`,
                  },
                  {
                    h: `Facebook Permissions`,
                    b: `The Site may by default access your Facebook basic account information, including your name, email, gender, birthday, current city, and profile picture URL, as well as other information that you choose to make public. We may also request access to other permissions related to your account, such as friends, checkins, and likes, and you may choose to grant or deny us access to each individual permission. For more information regarding Facebook permissions, refer to the Facebook Permissions Reference page.`,
                  },
                ]),
            },
            {
              h: "USE OF YOUR INFORMATION",
              b: ` Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:`,
              d: () =>
                bullet([
                  `Administer sweepstakes, promotions, and contests`,
                  `Assist law enforcement and respond to subpoena`,
                  `Compile anonymous statistical data and analysis for use internally or with third parties`,
                  `Create and manage your account`,
                  `Deliver targeted advertising, coupons, newsletters, and other information regarding promotions and the Site to you`,
                  `Email you regarding your account or order`,
                  `Enable user-to-user communications`,
                  `Fulfill and manage purchases, orders, payments, and other transactions related to the Site`,
                  `Generate a personal profile about you to make future visits to the Site more personalized`,
                  `Increase the efficiency and operation of the Site`,
                  `Monitor and analyze usage and trends to improve your experience with the Site`,
                  `Notify you of updates to the Sites`,
                  `Offer new products, services, and/or recommendations to you`,
                  `Perform other business activities as needed`,
                  `Prevent fraudulent transactions, monitor against theft, and protect against criminal activity`,
                  `Process payments and refunds`,
                  `Request feedback and contact you about your use of the Site`,
                  `Resolve disputes and troubleshoot problems`,
                  `Respond to product and customer service requests`,
                  `Send you a newsletter`,
                  `Solicit support for the Site`,
                ]),
            },
            {
              h: `Data From Social Networks`,
              b: `User information from social networking sites, such as Facebook, Google+, Instagram, Pinterest, Twitter, LinkedIn, including your name, your social network username, location, gender, birth date, email address, profile picture, and public data for contacts, if you connect your account to such social networks.`,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `Mobile Device Data`,
                    b: `Device information, such as your mobile device ID, model, and manufacturer, and information about the location of your device, if you access the Site from a mobile device.`,
                  },
                  {
                    h: `Third-Party Data`,
                    b: `Information from third parties, such as personal information or network friends, if you connect your account to the third party and grant the Site permission to access this information.`,
                  },
                  {
                    h: `Data From Contests, Giveaways, and Surveys`,
                    b: `Personal and other information you may provide when entering contests or giveaways and/or responding to surveys.`,
                  },
                ]),
            },
            {
              h: "DISCLOSURE OF YOUR INFORMATION",
              b: ` We may share information we have collected about you in certain situations. Your information may be disclosed as follows:`,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `By Law or to Protect Rights`,
                    b: `If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation. This includes exchanging information with other entities for fraud protection and credit risk reduction.`,
                  },
                  {
                    h: `Third-Party Service Providers`,
                    b: `We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.`,
                  },
                  {
                    h: `Marketing Communications`,
                    b: `With your consent, or with an opportunity for you to withdraw consent, we may share your information with third parties for marketing purposes, as permitted by law.`,
                  },
                  {
                    h: `Interactions with Other Users`,
                    b: `If you interact with other users of the Site, those users may see your name, profile photo, and descriptions of your activity, including sending invitations to other users, chatting with other users, liking posts, following blogs.`,
                  },
                  {
                    h: `Online Postings`,
                    b: `When you post comments, contributions or other content to the Site, your posts may be viewed by all users and may be publicly distributed outside the Site in perpetuity.`,
                  },
                  {
                    h: `Third-Party Advertisers`,
                    b: `We may use third-party advertising companies to serve ads when you visit the Site. These companies may use information about your visits to the Site and other websites that are contained in web cookies in order to provide advertisements about goods and services of interest to you.`,
                  },
                  {
                    h: `Affiliates`,
                    b: `We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any subsidiaries, joint venture partners or other companies that we control or that are under common control with us.`,
                  },
                  {
                    h: `Business Partners`,
                    b: `We may share your information with our business partners to offer you certain products, services or promotions.`,
                  },
                  {
                    h: `Social Media Contacts`,
                    b: `If you connect to the Site through a social network, your contacts on the social network will see your name, profile photo, and descriptions of your activity.`,
                  },
                  {
                    h: `Other Third Parties`,
                    b: `We may share your information with advertisers and investors for the purpose of conducting general business analysis. We may also share your information with such third parties for marketing purposes, as permitted by law.`,
                  },
                  {
                    h: `Sale or Bankruptcy`,
                    b: `If we reorganize or sell all or a portion of our assets, undergo a merger, or are acquired by another entity, we may transfer your information to the successor entity. If we go out of business or enter bankruptcy, your information would be an asset transferred or acquired by a third party. You acknowledge that such transfers may occur and that the transferee may decline honor commitments we made in this Privacy Policy.

      We are not responsible for the actions of third parties with whom you share personal or sensitive data, and we have no authority to manage or control third-party solicitations. If you no longer wish to receive correspondence, emails or other communications from third parties, you are responsible for contacting the third party directly.`,
                  },
                ]),
            },
            {
              h: `TRACKING TECHNOLOGIES`,
              b: ``,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `Cookies and Web Beacons`,
                    b: `We may use cookies, web beacons, tracking pixels, and other tracking technologies on the Site to help customize the Site and improve your experience. When you access the Site , your personal information is not collected through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject cookies, but be aware that such action could affect the availability and functionality of the Site. You may not decline web beacons. However, they can be rendered ineffective by declining all cookies or by modifying your web browser’s settings to notify you each time a cookie is tendered, permitting you to accept or decline cookies on an individual basis.

                    We may use cookies, web beacons, tracking pixels, and other tracking technologies on the Site to help customize the Site and improve your experience. For more information on how we use cookies, please refer to our Cookie Policy posted on the Site, which is incorporated into this Privacy Policy. By using the Site, you agree to be bound by our Cookie Policy.`,
                  },
                  {
                    h: `Internet-Based Advertising`,
                    b: `Additionally, we may use third-party software to serve ads on the Site, implement email marketing campaigns, and manage other interactive marketing initiatives. This third-party software may use cookies or similar tracking technology to help manage and optimize your online experience with us. For more information about opting-out of interest-based ads, visit the Network Advertising Initiative Opt-Out Tool or Digital Advertising Alliance Opt-Out Tool.`,
                  },
                  {
                    h: `Website Analytics`,
                    b: `We may also partner with selected third-party vendors, such as Google Analytics, and others, to allow tracking technologies and remarketing services on the Site through the use of first party cookies and third-party cookies, to, among other things, analyze and track users’ use of the Site, determine the popularity of certain content and better understand online activity. By accessing the Site, you consent to the collection and use of your information by these third-party vendors. You are encouraged to review their privacy policy and contact them directly for responses to your questions. We do not transfer personal information to these third-party vendors. However, if you do not want any information to be collected and used by tracking technologies, you can visit the third-party vendor or the Network Advertising Initiative Opt-Out Tool or Digital Advertising Alliance Opt-Out Tool.

                    You should be aware that getting a new computer, installing a new browser, upgrading an existing browser, or erasing or otherwise altering your browser’s cookies files may also clear certain opt-out cookies, plug-ins, or settings.`,
                  },
                ]),
            },
            {
              h: `SECURITY OF YOUR INFORMATION`,
              b: ``,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `General`,
                    b: `We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse. Any information disclosed online is vulnerable to interception and misuse by unauthorized parties. Therefore, we cannot guarantee complete security if you provide personal information.`,
                  },
                ]),
            },
            {
              h: `POLICY FOR CHILDREN`,
              b: ``,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `General`,
                    b: `We do not knowingly solicit information from or market to children under the age of 13. If you become aware of any data we have collected from children under age 13, please contact us using the contact information provided below.`,
                  },
                ]),
            },
            {
              h: `CONTROLS FOR DO-NOT-TRACK FEATURES`,
              b: ``,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `General`,
                    b: `Most web browsers and some mobile operating systems include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. No uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Policy./Most web browsers and some mobile operating systems include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. If you set the DNT signal on your browser, we will respond to such DNT browser signals.`,
                  },
                ]),
            },
            {
              h: `OPTIONS REGARDING YOUR INFORMATION`,
              b: ``,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `Account Information`,
                    b: (
                      <>
                        You may at any time review or change the information in
                        your account or terminate your account by:
                        <Box>
                          {bullet([
                            `Logging into your account settings and updating your account`,
                            `Contacting us using the contact information provided below`,
                          ])}
                        </Box>
                        Upon your request to terminate your account, we will
                        deactivate or delete your account and information from
                        our active databases. However, some information may be
                        retained in our files to prevent fraud, troubleshoot
                        problems, assist with any investigations, enforce our
                        Terms of Use and/or comply with legal requirements.`,
                      </>
                    ),
                  },
                  {
                    h: `Emails and Communications`,
                    b: (
                      <>
                        If you no longer wish to receive correspondence, emails,
                        or other communications from us, you may opt-out by:
                        <Box>
                          {bullet([
                            `Noting your preferences at the time you register your account with the Site`,
                            `Logging into your account settings and updating your preferences`,
                            `Contacting us using the contact information provided below`,
                          ])}
                        </Box>
                        If you no longer wish to receive correspondence, emails,
                        or other communications from third parties, you are
                        responsible for contacting the third party directly.,
                      </>
                    ),
                  },
                ]),
            },
            {
              h: `CALIFORNIA PRIVACY RIGHTS`,
              b: ``,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `General`,
                    b: `California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.

                    If you are under 18 years of age, reside in California, and have a registered account with the Site, you have the right to request removal of unwanted data that you publicly post on the Site. To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the Site, but please be aware that the data may not be completely or comprehensively removed from our systems.`,
                  },
                ]),
            },
            {
              h: `CONTACT US`,
              b: ``,
              d: (headingi) =>
                list(headingi, [
                  {
                    h: `General`,
                    b: `If you have questions or comments about this Privacy Policy, please contact us at:

                    Polycaik LLC
                    
                    contact@polycaik.com`,
                  },
                ]),
            },
          ].map((heading, headingi) => (
            <React.Fragment key={`${heading}${headingi}`}>
              <p>
                <strong>
                  <span>{heading.h}</span>
                </strong>
              </p>
              <p>{heading.b}</p>
              {heading.d(headingi)}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
